import { configureStore } from '@reduxjs/toolkit';
import { persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { persistedAdminReducer } from 'src/redux/admin/adminRootReducer';

const adminStore = configureStore({
  reducer: persistedAdminReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const adminPersistor = persistStore(adminStore);
const adminDispatch = adminStore.dispatch;

export { adminStore, adminPersistor, adminDispatch };
